import cn from 'classnames';
import { SizeProp } from 'types';

import styles from './CondensedControls.module.scss';
import CondensedPlaybackButton, {
  CondensedPlaybackButtonProps,
} from './CondensedPlaybackButton';
import ContinueListeningLink from './ContinueListeningLink';

type EndedStrategy =
  | 'episode-link' // show the "continue listening" link that redirects to full episode
  | 'initial'
  | 'custom'; // show the initial state (play button) so user can listen again

type ButtonProps = Pick<
  CondensedPlaybackButtonProps,
  'ariaVideoTitle' | 'icon' | 'loading' | 'onClick' | 'status'
>;

export interface CondensedControlsProps extends ButtonProps {
  className?: string;
  disabled?: boolean;
  buttonClassName?: string;
  endedStrategy?: EndedStrategy;
  /**
   * Only used when endedStrategy is 'custom'
   */
  endedContent?: React.ReactNode;
  size?: SizeProp;
}

const CondensedControls: React.FC<CondensedControlsProps> = ({
  ariaVideoTitle,
  icon,
  buttonClassName,
  className,
  disabled,
  endedContent = null,
  endedStrategy = 'episode-link',
  loading,
  onClick,
  size,
  status,
}) => (
  <div
    className={cn(
      styles.condensedControls,
      {
        [styles.condensedControls__ended]:
          status === 'ended' && endedStrategy === 'episode-link',
      },
      className,
    )}
  >
    {(() => {
      if (endedStrategy === 'initial' || status !== 'ended') {
        return (
          <CondensedPlaybackButton
            {...{ ariaVideoTitle, icon, disabled, loading, onClick, size }}
            className={buttonClassName}
            status={
              endedStrategy === 'initial' && status === 'ended'
                ? 'paused'
                : status
            }
          />
        );
      }

      if (endedStrategy === 'episode-link') {
        return <ContinueListeningLink />;
      }

      return endedContent;
    })()}
  </div>
);

export default CondensedControls;
